(function () {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
      }).format(cents / 100);
    } catch (e) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }
  };

  /* Reveal on scroll */
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' })
    : null;

  qsa('[data-reveal]').forEach((el, i) => {
    el.style.transitionDelay = (i % 4) * 80 + 'ms';
    if (io) io.observe(el);
    else el.classList.add('is-in');
  });

  /* Hero already in view */
  qsa('.hero-ritual [data-reveal]').forEach((el) => el.classList.add('is-in'));

  const drawer = qs('[data-side-cart]');
  const overlay = qs('[data-cart-overlay]');

  function openCart() {
    if (drawer) {
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
    }
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    renderCart();
  }

  function closeCart() {
    if (drawer) {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
    }
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
    closeGiftModal();
  }

  function openGiftModal() {
    const modal = qs('[data-free-gift-modal]');
    if (!modal) return;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
  }

  function closeGiftModal() {
    const modal = qs('[data-free-gift-modal]');
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
  }

  qsa('[data-cart-open]').forEach((b) => b.addEventListener('click', openCart));
  qsa('[data-cart-close], [data-cart-overlay]').forEach((b) => b.addEventListener('click', closeCart));

  qsa('.submenu-toggle').forEach((btn) => {
    btn.addEventListener('click', () => {
      const p = btn.closest('.nav-item');
      const o = p.classList.toggle('open');
      btn.setAttribute('aria-expanded', o ? 'true' : 'false');
    });
  });

  const menuBtn = qs('[data-menu-toggle]');
  const mobile = qs('[data-mobile-menu]');
  if (menuBtn && mobile) {
    menuBtn.addEventListener('click', () => {
      const o = mobile.classList.toggle('open');
      mobile.hidden = !o;
      menuBtn.setAttribute('aria-expanded', o ? 'true' : 'false');
    });
  }

  qsa('[data-mobile-submenu]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const sm = btn.parentElement.querySelector('.mobile-submenu');
      const o = sm.classList.toggle('open');
      btn.setAttribute('aria-expanded', o ? 'true' : 'false');
      const icon = btn.querySelector('span:last-child');
      if (icon) icon.textContent = o ? '−' : '+';
    });
  });

  async function getCart() {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }

  async function addItem(id, qty = 1) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity: Number(qty) })
    });
    if (!r.ok) throw new Error('add failed');
    await renderCart();
    openCart();
  }

  async function changeItem(key, qty) {
    const nextQty = Number(qty);
    try {
      const current = await getCart();
      const giftIds = getFreeGiftIds();
      const line = (current.items || []).find((item) => item.key === key);
      if (line && giftIds.includes(Number(line.variant_id)) && nextQty > 1) {
        updateFreeGift(current);
        return;
      }
    } catch (e) {}
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: nextQty })
    });
    await renderCart();
  }

  function updateCount(cart) {
    qsa('[data-cart-count]').forEach((el) => (el.textContent = cart.item_count));
    qsa('[data-cart-heading-count]').forEach((el) => (el.textContent = cart.item_count));
  }

  function updateMeter(cart) {
    const meter = qs('[data-shipping-meter]');
    if (!meter) return;
    const threshold = Number(meter.dataset.threshold || 0);
    const msg = qs('[data-shipping-message]', meter);
    const bar = qs('[data-shipping-bar]', meter);
    if (!threshold) return;
    const left = Math.max(threshold - cart.total_price, 0);
    const pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
    if (bar) bar.style.width = pct + '%';
    if (msg) {
      msg.textContent = left > 0
        ? 'Nog ' + money(left) + ' tot gratis verzending'
        : 'Je hebt gratis verzending bereikt';
    }
  }

  function getFreeGiftIds() {
    const box = qs('[data-free-gift]');
    if (!box) return [];
    const ids = qsa('[data-free-gift-option]', box)
      .map((b) => Number(b.dataset.variantId || 0))
      .filter(Boolean);
    const fallback = Number(box.dataset.variantId || 0);
    if (fallback && !ids.includes(fallback)) ids.push(fallback);
    return Array.from(new Set(ids));
  }

  function cartHasFreeGift(cart, giftIds = getFreeGiftIds()) {
    return giftIds.length
      ? (cart.items || []).some((item) => giftIds.includes(Number(item.variant_id)))
      : false;
  }

  async function cleanFreeGiftCart(cart) {
    const box = qs('[data-free-gift]');
    if (!box || box.dataset.enabled !== 'true') return cart;
    const threshold = Number(box.dataset.threshold || 4000);
    const giftIds = getFreeGiftIds();
    if (!threshold || !giftIds.length) return cart;
    const giftLines = (cart.items || []).filter((item) => giftIds.includes(Number(item.variant_id)));
    if (!giftLines.length) return cart;
    const shouldRemoveAll = Number(cart.total_price || 0) < threshold;
    const linesToRemove = shouldRemoveAll ? giftLines : giftLines.slice(1);
    if (!linesToRemove.length) return cart;
    await Promise.all(
      linesToRemove.map((line) =>
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: 0 })
        })
      )
    );
    return getCart();
  }

  function updateFreeGift(cart) {
    const box = qs('[data-free-gift]');
    if (!box) return;
    const enabled = box.dataset.enabled === 'true';
    const threshold = Number(box.dataset.threshold || 4000);
    const msg = qs('[data-free-gift-message]', box);
    const buttons = qsa('[data-free-gift-add]', box);
    const optionButtons = qsa('[data-free-gift-option]', box);
    const openButton = qs('[data-free-gift-open]', box);
    const giftIds = getFreeGiftIds();

    if (!enabled || !threshold) {
      box.hidden = true;
      return;
    }
    box.hidden = false;

    const total = Number(cart.total_price || 0);
    const eligible = total >= threshold;
    const hasAnyGift = cartHasFreeGift(cart, giftIds);
    const unconfigured = giftIds.length === 0;

    box.classList.toggle('is-eligible', eligible && !hasAnyGift && !unconfigured);
    box.classList.toggle('is-added', hasAnyGift);

    if (unconfigured) {
      if (msg) msg.textContent = 'Stel een cadeaucollectie of variant-ID in via de theme-instellingen.';
      buttons.forEach((btn) => (btn.disabled = true));
      if (openButton) openButton.hidden = true;
      closeGiftModal();
      return;
    }

    if (hasAnyGift) {
      if (msg) msg.textContent = 'Je gratis cadeau zit in je winkelwagen.';
      buttons.forEach((btn) => {
        btn.disabled = true;
        if (btn.classList.contains('free-gift-button')) btn.textContent = 'Toegevoegd';
      });
      optionButtons.forEach((btn) => btn.classList.add('is-disabled'));
      if (openButton) openButton.hidden = true;
      closeGiftModal();
      return;
    }

    const left = Math.max(threshold - total, 0);
    if (msg) {
      msg.textContent = eligible
        ? 'Je gratis cadeau staat klaar. Kies er één.'
        : 'Nog ' + money(left) + ' tot je gratis cadeau.';
    }
    if (openButton) {
      openButton.hidden = !eligible;
      openButton.disabled = !eligible;
    }
    if (!eligible) closeGiftModal();
    buttons.forEach((btn) => {
      const unavailable = btn.dataset.giftUnavailable === 'true';
      btn.disabled = !eligible || unavailable;
    });
    optionButtons.forEach((btn) => {
      const unavailable = btn.dataset.giftUnavailable === 'true';
      btn.disabled = !eligible || unavailable;
      btn.classList.toggle('is-disabled', !eligible || unavailable);
    });
  }

  async function renderCart() {
    if (!drawer) return;
    let cart = await getCart();
    cart = await cleanFreeGiftCart(cart);
    updateCount(cart);
    updateMeter(cart);
    updateFreeGift(cart);

    const items = qs('[data-cart-items]');
    const total = qs('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price);
    if (!items) return;

    if (!cart.items.length) {
      items.innerHTML =
        '<div class="side-cart__empty"><h3>Je winkelwagen is nog leeg</h3><p>Ontdek natuurlijke verzorging, handgemaakt op Kreta.</p><a class="btn btn--gold" href="/collections/all">Ontdek de collectie</a></div>';
      return;
    }

    const giftIds = getFreeGiftIds();
    items.innerHTML = cart.items
      .map((item) => {
        const isGift = giftIds.includes(Number(item.variant_id));
        const qtyControls = isGift
          ? `<div class="pro-drawer-qty"><span>${item.quantity}</span></div>`
          : `<div class="pro-drawer-qty"><button type="button" aria-label="Verlaag" data-change="${item.key}" data-qty="${item.quantity - 1}">−</button><span>${item.quantity}</span><button type="button" aria-label="Verhoog" data-change="${item.key}" data-qty="${item.quantity + 1}">+</button></div>`;
        return `<div class="drawer-line${isGift ? ' is-free-gift-line' : ''}">
          <a href="${item.url}">${item.image ? `<img src="${item.image}" alt="">` : ''}</a>
          <div>
            <a class="pro-line-title" href="${item.url}">${item.product_title}</a>
            ${isGift ? '<small class="pro-line-gift-label">Gratis cadeau</small>' : item.variant_title ? `<small>${item.variant_title}</small>` : ''}
            ${qtyControls}
          </div>
          <div class="pro-line-side">
            <strong>${money(item.final_line_price)}</strong>
            <button type="button" class="pro-remove" data-change="${item.key}" data-qty="0">Verwijderen</button>
          </div>
        </div>`;
      })
      .join('');

    qsa('[data-change]', items).forEach((b) =>
      b.addEventListener('click', () => changeItem(b.dataset.change, b.dataset.qty))
    );
  }

  document.addEventListener(
    'touchend',
    (e) => {
      const checkout = e.target.closest('[data-checkout-button]');
      if (!checkout) return;
      const form = checkout.closest('[data-sidecart-checkout-form]');
      if (!form) return;
      e.preventDefault();
      checkout.disabled = true;
      checkout.textContent = 'Door naar afrekenen…';
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    },
    { passive: false }
  );

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const fd = new FormData(form);
    try {
      await addItem(fd.get('id'), fd.get('quantity') || 1);
    } catch (err) {
      form.submit();
    }
  });

  document.addEventListener('click', async (e) => {
    const giftOpen = e.target.closest('[data-free-gift-open]');
    if (giftOpen) {
      e.preventDefault();
      if (!giftOpen.disabled) openGiftModal();
      return;
    }

    const giftClose = e.target.closest('[data-free-gift-close]');
    if (giftClose) {
      e.preventDefault();
      closeGiftModal();
      return;
    }

    const gift = e.target.closest('[data-free-gift-add]');
    if (gift) {
      e.preventDefault();
      const box = gift.closest('[data-free-gift]');
      const id = gift.dataset.variantId || (box ? box.dataset.variantId : null);
      if (!id || gift.disabled) return;
      gift.disabled = true;
      const oldText = gift.textContent;
      try {
        const current = await getCart();
        const giftIds = getFreeGiftIds();
        if (cartHasFreeGift(current, giftIds)) {
          await renderCart();
          return;
        }
        const threshold = Number(box?.dataset.threshold || 4000);
        if (Number(current.total_price || 0) < threshold) {
          updateFreeGift(current);
          gift.disabled = false;
          gift.textContent = oldText;
          return;
        }
        await addItem(id, 1);
        closeGiftModal();
      } catch (err) {
        gift.disabled = false;
        gift.textContent = oldText;
      }
      return;
    }

    const checkout = e.target.closest('[data-checkout-button]');
    if (checkout) {
      const form = checkout.closest('[data-sidecart-checkout-form]');
      if (form) {
        e.preventDefault();
        checkout.disabled = true;
        checkout.textContent = 'Door naar afrekenen…';
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      }
      return;
    }

    const qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      await addItem(qa.dataset.variantId, 1);
    }

    const pm = e.target.closest('[data-qty-minus]');
    if (pm) {
      const inp = pm.parentElement.querySelector('input');
      inp.value = Math.max(1, Number(inp.value || 1) - 1);
    }
    const pp = e.target.closest('[data-qty-plus]');
    if (pp) {
      const inp = pp.parentElement.querySelector('input');
      inp.value = Number(inp.value || 1) + 1;
    }

    const stickyAdd = e.target.closest('[data-sticky-add]');
    if (stickyAdd) {
      e.preventDefault();
      const submit = document.querySelector('.product-form .add-to-cart');
      const form = document.querySelector('[data-product-form]');
      if (submit && !submit.disabled) submit.click();
      else if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeGiftModal();
      closeCart();
    }
  });

  qsa('[data-accordion] button').forEach((btn) => {
    btn.addEventListener('click', () => {
      const panel = btn.nextElementSibling;
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (panel) panel.hidden = expanded;
    });
  });

  document.addEventListener('click', async (e) => {
    const a = e.target.closest('[data-cart-line-change]');
    if (!a) return;
    e.preventDefault();
    a.style.pointerEvents = 'none';
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(a.dataset.line), quantity: Number(a.dataset.qty) })
      });
      window.location.reload();
    } catch (err) {
      window.location.href = a.href;
    }
  });

  /* Routine builder */
  qsa('[data-routine-builder]').forEach((builder) => {
    let need = 'hair-loss';
    let level = 'essential';
    const cards = qsa('[data-routine-card]', builder);
    const fallback = qs('[data-routine-fallback]', builder);

    function showMatch() {
      const match =
        cards.find((c) => c.dataset.need === need && c.dataset.level === level) ||
        cards.find((c) => c.dataset.need === need) ||
        cards[0];
      cards.forEach((c) => c.classList.add('hidden'));
      if (fallback) fallback.classList.add('hidden');
      if (match) match.classList.remove('hidden');
      else if (fallback) fallback.classList.remove('hidden');
    }

    qsa('[data-routine-need]', builder).forEach((btn) =>
      btn.addEventListener('click', () => {
        need = btn.dataset.routineNeed;
        qsa('[data-routine-need]', builder).forEach((b) => b.classList.toggle('is-active', b === btn));
        showMatch();
      })
    );
    qsa('[data-routine-level]', builder).forEach((btn) =>
      btn.addEventListener('click', () => {
        level = btn.dataset.routineLevel;
        qsa('[data-routine-level]', builder).forEach((b) => b.classList.toggle('is-active', b === btn));
        showMatch();
      })
    );
    qsa('[data-routine-add]', builder).forEach((btn) =>
      btn.addEventListener('click', async () => {
        const ids = (btn.dataset.variantIds || '')
          .split(',')
          .map((x) => x.trim())
          .filter(Boolean);
        if (!ids.length) {
          btn.textContent = 'Koppel eerst producten';
          btn.disabled = true;
          return;
        }
        btn.disabled = true;
        const old = btn.textContent;
        btn.textContent = 'Routine toevoegen…';
        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })) })
          });
          await renderCart();
          openCart();
          btn.textContent = 'Toegevoegd';
          setTimeout(() => {
            btn.disabled = false;
            btn.textContent = old;
          }, 1400);
        } catch (err) {
          btn.disabled = false;
          btn.textContent = 'Probeer opnieuw';
        }
      })
    );
    showMatch();
  });

  /* Wishlist */
  const WISHLIST_KEY = 'evergetikon_wishlist_v1';
  function readWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }
  function writeWishlist(items) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
    updateWishlistUI();
  }
  function isWishlisted(handle) {
    return readWishlist().some((i) => i.handle === handle);
  }
  function updateWishlistUI() {
    const items = readWishlist();
    qsa('[data-wishlist-count]').forEach((el) => {
      el.textContent = items.length;
      el.classList.toggle('is-zero', items.length === 0);
    });
    qsa('[data-wishlist-toggle]').forEach((btn) => {
      const saved = isWishlisted(btn.dataset.productHandle);
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      const label = btn.querySelector('span');
      if (label) label.textContent = saved ? 'Bewaard op verlanglijst' : 'Bewaar op verlanglijst';
    });
    renderWishlistPage();
  }
  function toggleWishlist(btn) {
    const item = {
      handle: btn.dataset.productHandle,
      title: btn.dataset.productTitle,
      url: btn.dataset.productUrl,
      image: btn.dataset.productImage,
      price: btn.dataset.productPrice,
      variantId: btn.dataset.variantId
    };
    if (!item.handle) return;
    let items = readWishlist();
    if (items.some((i) => i.handle === item.handle)) {
      items = items.filter((i) => i.handle !== item.handle);
    } else {
      items.unshift(item);
    }
    writeWishlist(items.slice(0, 60));
  }
  function renderWishlistPage() {
    const grid = qs('[data-wishlist-grid]');
    if (!grid) return;
    const empty = qs('[data-wishlist-empty]');
    const items = readWishlist();
    if (empty) empty.classList.toggle('hidden', items.length > 0);
    grid.innerHTML = items
      .map(
        (item) => `<article class="product-card">
        <a class="product-card__media" href="${item.url || '#'}">${item.image ? `<img src="${item.image}" alt="">` : ''}</a>
        <div class="product-card__info">
          <a href="${item.url || '#'}"><h3>${item.title || 'Product'}</h3></a>
          <div class="price-row"><strong>${item.price || ''}</strong></div>
          <div style="display:grid;gap:.5rem">
            ${item.variantId ? `<button class="btn btn--gold btn--small" type="button" data-quick-add data-variant-id="${item.variantId}">In winkelwagen</button>` : ''}
            <button class="btn btn--ghost btn--small" type="button" data-wishlist-remove="${item.handle}">Verwijderen</button>
          </div>
        </div>
      </article>`
      )
      .join('');
  }

  document.addEventListener('click', (e) => {
    const w = e.target.closest('[data-wishlist-toggle]');
    if (w) {
      e.preventDefault();
      e.stopPropagation();
      toggleWishlist(w);
      return;
    }
    const r = e.target.closest('[data-wishlist-remove]');
    if (r) {
      e.preventDefault();
      writeWishlist(readWishlist().filter((i) => i.handle !== r.dataset.wishlistRemove));
    }
  });

  updateWishlistUI();
  renderCart().catch(() => {});
})();
